import { gql } from 'apollo-boost';

export const createMutation = gql`
  mutation createContribution($inputData: ContributionInputObjectType!) {
    createContribution(inputData: $inputData) {
      ok
      errors {
        code
        field
        messages
      }
    }
  }
`;

export const createBulkMutation = gql`
  mutation createBulkContribution(
    $inputData: BulkContributionInputObjectType!
  ) {
    createBulkContribution(inputData: $inputData) {
      ok
      errors {
        code
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateContribution(
    $id: Int!
    $inputData: ContributionInputObjectType!
  ) {
    updateContribution(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteContribution($id: Int!) {
    deleteContribution(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const manyQuery = gql`
  query contributions($inputFilter: ContributionFilterInputObjectType) {
    contributions(inputFilter: $inputFilter) {
      id
      userId
      year
      amount
      type
      addedAt
      createdAt
      updatedAt
      trainerId
      trainer {
        id
        fullName
      }
      gym {
        id
        name
      }
      gymId
    }
  }
`;

const oneQuery = gql`
  query contribution($id: Int!) {
    contributions(id: $id) {
      id
      userId
      year
      amount
      type
      addedAt
      createdAt
      updatedAt
    }
  }
`;

const contributionUserListQuery = gql`
  query contributionUserList($inputFilter: ContributionUserInputFilter) {
    contributionUserList(inputFilter: $inputFilter) {
      id
      fullName
      status
      transfer
      amount
      payToAnother
      isAthlete
      transferToTrainerId
      payToAnotherTrainerId
      contributionGym {
        id
        name
      }
      club {
        shortName
      }
      gyms {
        id
        name
      }
    }
  }
`;

const contributionTrainerListQuery = gql`
  query contributionTrainerList($inputFilter: ContributionTrainerInputFilter) {
    contributionTrainerList(inputFilter: $inputFilter) {
      id
      fullName
      status
      amount
      athleteCount
      athleteWithContributionCount
      club {
        shortName
      }
      gyms {
        id
        name
      }
      contributionGyms {
        id
        name
      }
    }
  }
`;

const contributionAvailableGymsListQuery = gql`
  query contributionAvailableGymsList(
    $inputFilter: ContributionAvailableGymsInputObjectType
  ) {
    contributionAvailableGymsList(inputFilter: $inputFilter) {
      athleteId
      athlete {
        id
        fullName
      }
      gyms {
        id
        name
      }
      groups {
        id
        name
        gym {
          id
          name
        }
        sectionObj {
          id
          name
        }
      }
    }
  }
`;

const CONTRIBUTIONS = {
  createMutation,
  createBulkMutation,
  updateMutation,
  deleteMutation,
  manyQuery,
  oneQuery,
  contributionUserListQuery,
  contributionTrainerListQuery,
  contributionAvailableGymsListQuery,
};

export default CONTRIBUTIONS;
